import SignUpReducer from "./signUpReducer";
import companyListingReducer from "./companyListingReducer";
import companyDetailsReducer from "./companyDetailsReducer";
import executiveListingReducer from "./executiveListingReducer";
import executiveDetailsReducer from "./executiveDetailsReducer";
import HeaderReducer from "./headerReducer";
import leadListingReducer from "./leadListingReducer";
import LeadDetailsReducer from "./leadDetailsReducer";
import CommonReducer from "./commonReducer";
import DashboardReducer from "./dashboardReducer";
import WebToLeadReducer from "./webToLeadReducer";
import { combineReducers } from "redux";
import emailSetupReducer from "./emailSetupReducer";
import socialAuthReducer from "./socialAuthReducer";
import ReputationMangerReducer from "./reputationManagerReducer";
import UserManagementReducer from "./userManagementReducer";
import roleManagementReducer from "./roleManagementReducer";
import teamManagementReducer from "./teamManagerReducer";
import paymentReducer from "./paymentReducer";
import importReducer from "./importReducer";
import calendarReducer from "./calendarReducer";
import meetingTypeReducer from "./meetingTypeReducer";
import availabilityReducer from "./availabilityReducer";
import { genAIReducer } from "./genAIReducer";
import publicMeetingLinkReducer from "./publicMeetingLinkReducer";

const rootReducer = combineReducers({
  CommonReducer,
  HeaderReducer,
  SignUpReducer,
  companyListingReducer,
  companyDetailsReducer,
  executiveListingReducer,
  executiveDetailsReducer,
  leadListingReducer,
  LeadDetailsReducer,
  DashboardReducer,
  WebToLeadReducer,
  emailSetupReducer,
  socialAuthReducer,
  ReputationMangerReducer,
  UserManagementReducer,
  roleManagementReducer,
  teamManagementReducer,
  paymentReducer,
  importReducer,
  calendarReducer,
  meetingTypeReducer,
  availabilityReducer,
  genAIReducer,
  publicMeetingLinkReducer,
});

export default rootReducer;
